import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import AccountFormEmailContainer from 'src/app/containers/Registration/Account/AccountFormEmailContainer';
import AccountFormPasswordContainer from 'src/app/containers/Registration/Account/AccountFormPasswordContainer';
import AccountFormAgreementsRegulationsContainer
  from 'src/app/containers/Registration/Account/AccountFormAgreementsRegulationsContainer';
import AccountFormAgreementsMarketingContainer
  from 'src/app/containers/Registration/Account/AccountFormAgreementsMarketingContainer';
import AccountFormFacebook from 'src/app/containers/Registration/Account/AccountFormFacebookContainer';
import { sendAccountForm } from 'src/app/redux/actions/registration/account/accountForm';
import {
  accountEmailSetVisualization,
  accountEmailSetValidationMessage
} from 'src/app/redux/actions/registration/account/accountFormEmail';
import {
  accountFormPasswordSetValidationMessage,
  accountFormPasswordSetVisualization
} from 'src/app/redux/actions/registration/account/accountFormPassword';
import {
  accountFormRegulationsSetValidationMessage
} from 'src/app/redux/actions/registration/account/accountFormAgreementsRegulations';
import 'src/app/containers/Registration/Account/AccountFormContainer.scss';


class AccountFormContainer extends React.Component {
  regulationsCheckboxRef = React.createRef();

  passwordInputRef = React.createRef();

  emailInputRef = React.createRef();

  dispatchErrorVisualization = () => {
    const { emailInputRef, passwordInputRef, regulationsCheckboxRef } = this;
    const { dispatch } = this.props;

    dispatch(accountEmailSetValidationMessage(emailInputRef.current.validationMessage));
    dispatch(accountEmailSetVisualization(true));
    dispatch(accountFormPasswordSetValidationMessage(passwordInputRef.current.validationMessage));
    dispatch(accountFormPasswordSetVisualization(true));
    dispatch(accountFormRegulationsSetValidationMessage(regulationsCheckboxRef.current.validationMessage));
  };

  onSubmit = (event) => {
    event.preventDefault();
    const { dispatch, email, password, marketingAgreements } = this.props;

    const form = event.target;
    if (!form.checkValidity()) {
      form.scrollIntoView();
      this.dispatchErrorVisualization();
      return;
    }

    dispatch(sendAccountForm(email, password, marketingAgreements));
  };

  render() {
    const { onSubmit, emailInputRef, passwordInputRef, regulationsCheckboxRef } = this;
    const { sending } = this.props;

    return (
      <React.Fragment>
        <form onSubmit={ onSubmit } noValidate styleName="account-details">

          <h2 styleName="account-details__title">Zarejestruj się</h2>

          <div styleName="account-details__input">
            <AccountFormEmailContainer inputRef={ emailInputRef }/>
          </div>

          <div styleName="account-details__input">
            <AccountFormPasswordContainer inputRef={ passwordInputRef }/>
          </div>


          <AccountFormAgreementsRegulationsContainer inputRef={ regulationsCheckboxRef }/>

          <AccountFormAgreementsMarketingContainer/>


          <p styleName="account-details__asterisk-explanation">
            Obowiązkowe zgody
          </p>

          <button type="submit"
                  styleName="account-details__button-submit"
                  disabled={ sending }
                  data-test="button-registration"
          >
            Zarejestruj się
          </button>

        </form>

        <AccountFormFacebook regulationsCheckboxRef={ regulationsCheckboxRef }/>
      </React.Fragment>
    );
  }
}

AccountFormContainer.propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  marketingAgreements: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    extendedText: PropTypes.string,
    id: PropTypes.number,
    links: PropTypes.array,
    text: PropTypes.string
  })).isRequired
};

const mapStateToProps = (store) => ({
  email: store.accountFormEmailReducer.value,
  password: store.accountFormPasswordReducer.value,
  marketingAgreements: store.accountFormAgreementsReducer.agreements,
  regulationChecked: store.accountFormRegulationsReducer.checked,
  sending: store.accountFormReducer.sending
});

export default connect(mapStateToProps)(AccountFormContainer);
